import { ValidateSignupSessionDocument, ValidateSignupSessionQueryVariables, ValidateSignupSessionQuery } from "@/graphql/__generated__/graphql";
import { useLazyQuery } from "@apollo/client/react";
import { Dispatch, SetStateAction, useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export const useValidateSignupSessionLazyQueryHook = (setEmail: Dispatch<SetStateAction<string | null>>, form: UseFormReturn<any>, setIsValidating: Dispatch<SetStateAction<boolean>>) => {

  // Hooks
  const navigate = useNavigate();

  const [validateSignupSession, { data, loading, error }] = useLazyQuery<ValidateSignupSessionQuery, ValidateSignupSessionQueryVariables>(ValidateSignupSessionDocument);

  useEffect(() => {
    if (data) {
      if (!data?.validateSignupSession.valid) {
        navigate("/login", { replace: true });
        return;
      }
      const validatedEmail = data.validateSignupSession.email as string;
      setEmail(validatedEmail);
      form.setValue("email", validatedEmail);
      sessionStorage.setItem("email", validatedEmail);
      // Successfully validated; allow user to proceed with auth choices
      setIsValidating(false);
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      navigate("/login", { replace: true });
      setIsValidating(false);
    }
  }, [error]);

  return {
    validateSignupSession,
    loading,
    error
  };
};
